// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".full-width-video-loop{position:relative;overflow:hidden;background-color:#1f3534}.full-width-video-loop_video{position:absolute;top:0;left:0;width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
